import { saveAs } from 'file-saver';
import { Buffer } from 'buffer';

export const extractFileNameFromUrlAndSave = (url) => {
	// Extract the filename out of the URL
	const fileName = /output\/.*\/(.*)$/.exec(url)?.[1];
	if (!fileName) {
		throw new Error('No file name');
	}

	// Get the browser to download it.
	saveAs(url, fileName);
};

/***
 * Converts a dataUrl base64 image string into a File byte array
 * dataUrl example:
 * data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAACLCAYAAABRGWr/AAAAAXNSR0IA...etc
 */
export const dataUrlToFile = (dataUrl: string, filename: string): File | undefined => {
	const arr = dataUrl.split(',');
	if (arr.length < 2) {
		return undefined;
	}
	const mimeArr = arr[0].match(/:(.*?);/);
	if (!mimeArr || mimeArr.length < 2) {
		return undefined;
	}
	const mime = mimeArr[1];
	const buff = Buffer.from(arr[1], 'base64');
	return new File([buff], filename, { type: mime });
};

export const readFile = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			if (e.target?.result) {
				resolve(e.target.result as string);
			} else {
				reject(new Error('No result'));
			}
		};
		reader.onerror = (e) => {
			reject(e);
		};
		reader.readAsDataURL(file);
	});
};
